import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanize'
})
export class HumanizePipe implements PipeTransform {
  transform(value: any): string {
    return value.replace(/([A-Z])/g, ' $1').replace(/^./, m => m.toUpperCase());
  }
}
